<template>
  <div
    ref="scrollTable"
    class="pega-scroll-table"
    data-test="scroll-table"
    @scroll="onScroll"
  >
    <table class="boss-table-4">
      <tr>
        <th
          class="pega-input"
          data-test="all-check"
          @click="checkedAll()"
        >
          <input
            type="checkbox"
            class="boss-input-checkbox"
            :checked="isAllCheck"
          >
        </th>
        <th>応募日</th>
        <th>応募者</th>
        <th class="is-boss-only-pc">
          求人
        </th>
        <th>
          <div
            class="relative"
          >
            <span
              v-tooltip="{ content: 'スカウト（特典内容も含む）、DM、いいね送信済みの場合にアイコンが表示されます。応募期限内のものは濃色で表示、応募期限外のものは薄色で表示されます。'}"
              class="pega-circle"
              data-test="tooltip-approach"
            >?</span>
            <div>アプローチ状況</div>
          </div>
        </th>
        <th>メッセージ</th>
        <template v-for="(displayItem) in displayItems">
          <th
            v-if="displayItem === 'phase'"
            :key="displayItem"
            class="is-boss-only-pc"
            data-test="phase"
          >
            <div class="relative">
              <span
                v-tooltip="{ content: '選考フェーズの設定・編集は、「各種設定」メニューで行えます。'}"
                class="pega-circle"
                data-test="tooltip-phase"
              >?</span>
              <div>
                選考
                <br>フェーズ
              </div>
            </div>
          </th>
          <th
            v-if="displayItem === 'status'"
            :key="displayItem"
            class="is-boss-only-pc"
            data-test="status"
          >
            <div class="relative">
              <span
                v-tooltip="{ content: '選考ステータスの設定・編集は、「各種設定」メニューで行えます。'}"
                class="pega-circle"
                data-test="tooltip-status"
              >?</span>
              <div>
                選考
                <br>ステータス
              </div>
            </div>
          </th>
          <th
            v-if="displayItem === 'remarks'"
            :key="displayItem"
            class="is-boss-only-pc"
            data-test="remarks"
          >
            備考
          </th>
          <th
            v-if="displayItem === 'responsible_staffs'"
            :key="displayItem"
            class="is-boss-only-pc"
            data-test="responsible_staffs"
          >
            人事担当
          </th>
          <th
            v-if="displayItem === 'evaluation'"
            :key="displayItem"
            class="is-boss-only-pc"
            data-test="evaluation"
          >
            評価
          </th>
          <th
            v-if="displayItem === 'comment'"
            :key="displayItem"
            class="is-boss-only-pc"
            data-test="comment"
          >
            評価コメント
          </th>
        </template>
      </tr>
      <applicant-outline
        v-for="(applicantObject, key) in infinityApplicantObjects"
        :key="key"
        :display-target="displayTarget"
        :applicant-object="applicantObject"
        :display-items="displayItems"
        @update-checked="updateChecked"
        @update-selections="updateSelections"
      />
    </table>
    <infinite-loading
      ref="infiniteLoading"
      @infinite="infiniteHandler"
    >
      <div
        slot="no-more"
        data-test="infinite-loading-no-more"
      >
        全{{ renderingApplicantObjects.length }}名
      </div>
      <div slot="no-results">
        応募者がいません。
      </div>
      <div slot="spinner" />
    </infinite-loading>
    <selected-counter :checked-count="checkedCount" />
  </div>
</template>

<style scoped>
.pega-circle {
  font-size: .6em;
  cursor: pointer;
  margin-left: 5px;
  position: absolute;
  top: -2px;
  right: -2px;
}
.relative {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
table, tr, th {
  height: 100%;
}
th > div {
  height: 100%;
  width: 100%;
}
</style>
<script>
import ApplicantOutline from '@/components/molecules/ApplicantOutline'
import SelectedCounter from '@/components/molecules/SelectedCounter'
import _ from 'lodash'
import InfiniteLoading from 'vue-infinite-loading'
import InfinityScrollIterator from '@/lib/infinityScrollIterator'
import { mapGetters } from 'vuex'
import { hideAllPoppers } from 'floating-vue'

export default {
  components: {
    ApplicantOutline,
    SelectedCounter,
    InfiniteLoading
  },
  props: {
    applicantObjects: {
      type: Array,
      required: true
    },
    displayTarget: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      infinityApplicantObjects: [],
      displayItems: [],
      pastScrollTop: 0
    }
  },
  computed: {
    renderingApplicantObjects () {
      return _(this.applicantObjects)
        .filter('isShow')
        .filter('isDisplayTarget')
        .value()
    },
    checkedCount () {
      return _(this.renderingApplicantObjects).filter('isChecked').value().length
    },
    isAllCheck () {
      return this.renderingApplicantObjects.length
        ? this.renderingApplicantObjects.every(renderingApplicantObject => renderingApplicantObject.isChecked)
        : false
    },
    ...mapGetters('settings', [
      'allStatuses'
    ])
  },
  watch: {
    renderingApplicantObjects (val) {
      if (_.has(this.$refs, 'infiniteLoading.stateChanger')) {
        this.$refs.infiniteLoading.stateChanger.reset()
      }
      this.infinityApplicantObjects = []
      this.infinityScrollIterator = new InfinityScrollIterator(val, 50)
    }
  },
  created () {
    this.$http.secured.get('/entry/view/display_items').then(response => {
      this.$set(this, 'displayItems', response.data)
    })
  },
  methods: {
    checkedAll () {
      const isChecked = !this.isAllCheck
      _.forEach(this.renderingApplicantObjects, o => { o.isChecked = isChecked })
    },
    updateChecked (data) {
      const index = this.renderingApplicantObjects.findIndex(applicantObject => applicantObject.applicant.id === data.id)
      this.$set(this.renderingApplicantObjects[index], 'isChecked', data.isChecked)
    },
    updateSelections (val) {
      this.$http.secured.get(`/entry/view/entries/${val}/current_selection`).then(response => {
        const currentSelection = response.data
        _.set(currentSelection, 'statusOrder', this.getStatusOrder(currentSelection.statusId))
        this.$set(_.find(this.renderingApplicantObjects, _.matchesProperty('applicant.id', val)).applicant, 'currentSelection', currentSelection)
      })
    },
    onScroll () {
      this.$set(this, 'pastScrollTop', this.$refs.scrollTable.scrollTop)
      hideAllPoppers() // 表示しているツールチップの削除
    },
    scrollTo (top) {
      this.$refs.scrollTable.scrollTo({ top })
    },
    infiniteHandler ($state) {
      if (this.infinityScrollIterator) {
        const next = this.infinityScrollIterator.next()
        if (next.done) {
          $state.complete()
        } else {
          this.infinityApplicantObjects.push(...next.value)
          if (this.pastScrollTop > this.$refs.scrollTable.scrollTop) {
            this.$nextTick(() => {
              this.scrollTo(this.pastScrollTop)
            })
          }
          $state.loaded()
        }
      }
    },
    getStatusOrder (statusId) {
      return statusId ? _.findIndex(this.allStatuses, status => status.id === statusId) : null
    }
  }
}
</script>
